// IBM Plex Mono (CP-дизайн): полные woff2 из официального пакета @ibm/plex-mono.
// Пакет @fontsource/ibm-plex-mono вырезает OpenType-фичи (нет zero, ss01…), поэтому он не подходит
// для font-feature-settings: 'zero' и т.п. Файлы шрифта грузятся браузером только при использовании.
import regular from '@ibm/plex-mono/fonts/complete/woff2/IBMPlexMono-Regular.woff2';
import medium from '@ibm/plex-mono/fonts/complete/woff2/IBMPlexMono-Medium.woff2';
import semiBold from '@ibm/plex-mono/fonts/complete/woff2/IBMPlexMono-SemiBold.woff2';
import bold from '@ibm/plex-mono/fonts/complete/woff2/IBMPlexMono-Bold.woff2';

const face = (weight, url) => `
@font-face {
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: ${weight};
  font-display: swap;
  src: url(${url}) format('woff2');
}
`;

export const plexMonoFontFace = face(400, regular) + face(500, medium) + face(600, semiBold) + face(700, bold);
